import React from "react";

import { Container, Grid, TextField, Button, Box, Typography } from '@mui/material';
export const textCOC = () => {
return(            <Box>
    <Typography variant="h4" gutterBottom fontWeight="bold">
        CODE OF CONDUCT
    </Typography>

    <Typography variant="h6" gutterBottom fontWeight="bold">
        Introduction
    </Typography>
    <Typography variant="body1" paragraph>
        The purpose of the Code of Conduct and Discipline Policy is to ensure that all students, parents, teachers and staff are aware of acceptable behaviour at The International School, and the repercussions for any inappropriate behaviour.
    </Typography>
    <Typography variant="body1" paragraph>
        The Code of Conduct is based on three simple concepts that all students should follow:
    </Typography>
    <Box component="ul" sx={{ pl: 4 }}>
        <Typography component="li" variant="body1" paragraph>
            cooperation with your teachers, administrators and classmates
        </Typography>
        <Typography component="li" variant="body1" paragraph>
            respect the rights and property of others
        </Typography>
        <Typography component="li" variant="body1" paragraph>
            carry out your responsibilities as a student
        </Typography>
    </Box>

    <Typography variant="h6" gutterBottom fontWeight="bold">
        Attendance and Punctuality
    </Typography>
    <Typography variant="body1" paragraph>
        2.1 Attendance Requirements
    </Typography>
    <Typography variant="body1" paragraph>
        Student attendance is of primary importance at TIS. Students should make all efforts to attend school every day of the school year. Parents are strongly encouraged to not excuse students from school for the purposes of extending vacations, appointments, outside activities or for minor ailments.
    </Typography>
    <Typography variant="body1" paragraph>
        Students are responsible for all work that takes place during an absence; it is the student's responsibility to contact his/her teachers to make up missing assignments and to learn about all work that has taken place. The school does not condone the unnecessary absence of students and respects the rights of students present, not to be affected by those who are absent. It is important that students, parents and school staff co-operate to ensure attendance and punctuality.
    </Typography>
    <Typography variant="body1" paragraph>
        2.2 Excused Absence
    </Typography>
    <Typography variant="body1" paragraph>
        If a student is absent, he or she must provide a written explanation, signed by the parent, on the following morning by 8:00am and submit it to the class teacher or Coordinator. There is no penalty for an excused absence, however, the student is responsible for obtaining any work that was missed. Any assignments due on the day of absence must be submitted the next day. However, MVP monthly tests will not be rescheduled under any circumstances.
    </Typography>
    <Typography variant="body1" paragraph>
        Students, who are not present in school by 8:00am, cannot come into school, whether in uniform or home clothes, to make any submissions or attend classes of any kind. Parents will be emailed/telephoned on the day of a student's absence and reminded of the necessary written excuse. Extended absences for medical reasons must be accompanied by a doctor's note. If parents know of a student's absence in advance, especially an extended absence, then the school asks that notice be given to the office staff.
    </Typography>
    <Typography variant="body1" paragraph>
        2.3 Unexcused Absence
    </Typography>
    <Typography variant="body1" paragraph>
        If a student is absent and does not provide a written explanation signed by a parent, he or she will be marked down for an unexcused absence. Any assignments passed in late or not submitted because of an unexcused absence will not be extended or accepted.
    </Typography>
    <Typography variant="body1" paragraph>
        After a student's second unexcused absence, he or she will be issued a lunch break detention by the class teacher/Coordinator. If a third unexcused absence occurs, the student will be issued an after-school detention. In addition, a meeting will be scheduled with the parents, student and Coordinator to discuss the student's attendance.
    </Typography>
    <Typography variant="body1" paragraph>
        2.4 Absence from Class
    </Typography>
    <Typography variant="body1" paragraph>
        If at any time a student is caught bunking a scheduled class, he or she will be given a non-submission and the parents will be informed. The second offence will lead to disciplinary action and possible suspension.
    </Typography>
    <Typography variant="body1" paragraph>
        2.5 Late Arrivals to School
    </Typography>
    <Typography variant="body1" paragraph>
        It is absolutely essential that students arrive on time for school in the morning. Students are expected to arrive before 7:50am. Any arrival between 7:50am and 8:00am will be considered a late arrival. The gate will close at 8:00am sharp. The third late arrival will result in the student being sent home. No student will be allowed to enter school after 8:00am.
    </Typography>
    <Typography variant="body1" paragraph>
        2.6 Late Arrivals to Class
    </Typography>
    <Typography variant="body1" paragraph>
        If a student is late for class without justification, he or she will be warned and the incident will be reported to the Disciplinary Committee and Coordinator via e-mail. The second offence will result in action being taken by the Disciplinary Committee.
    </Typography>
    <Typography variant="body1" paragraph>
        2.7 Appointments During School Hours
    </Typography>
    <Typography variant="body1" paragraph>
        The school strongly discourages any appointments during school hours. In the case that an appointment is unavoidable, the student should not be sent to school as he/she will not be allowed to leave early or arrive late. For this absence to be considered excused, the parent must provide a letter/email of excuse.
    </Typography>

    <Typography variant="h6" gutterBottom fontWeight="bold">
        Preparation for Class
    </Typography>
    <Typography variant="body1" paragraph>
        Students must be prepared for class with all their required texts, notebooks/paper and materials. Not being prepared for a particular class restricts a student's ability to learn and often causes a disruption for the teacher and the class. Forgetting a copy or text at home is not a valid excuse for not submitting work on time. If a student is continually unprepared for class, parents will be informed by the concerned teacher.
    </Typography>

    <Typography variant="h6" gutterBottom fontWeight="bold">
        Honesty and Respect
    </Typography>
    <Typography variant="body1" paragraph>
        The values of the school are based on honesty and respect. Students must be honest in all of their day to day dealings at The International School. They must also show respect for their classmates, teachers, administrators and school staff. Parents will be notified if a student is:
    </Typography>
    <Box component="ul" sx={{ pl: 4 }}>
        <Typography component="li" variant="body1" paragraph>
            caught disrespecting a teacher or member of the staff
        </Typography>
        <Typography component="li" variant="body1" paragraph>
            using foul or disrespectful language toward anyone on school grounds
        </Typography>
        <Typography component="li" variant="body1" paragraph>
            displaying disruptive behaviour in class
        </Typography>
        <Typography component="li" variant="body1" paragraph>
            displays any kind of inappropriate/violent physical and/or verbal behaviour towards another student or member of staff
        </Typography>
    </Box>

    <Typography variant="h6" gutterBottom fontWeight="bold">
        Academic Honesty
    </Typography>
    <Typography variant="body1" paragraph>
        Students must understand the basic meaning and significance of concepts that relate to academic honesty. Academic honesty is the original authorship and ownership of their own authentic work in all assessments and exams. An authentic piece of work is that which is based on the student's individual and original ideas, with the ideas and work of others fully acknowledged.
    </Typography>
    <Typography variant="body1" paragraph>
        Use of Sources
    </Typography>
    <Typography variant="body1" paragraph>
        The most frequent example of malpractice is plagiarism. This is using the ideas or work of another person as the student's own. Any other behaviour that results in, or may result in, the student gaining an unfair advantage in one or more assessment components.
    </Typography>
    <Typography variant="body1" paragraph>
        Penalties are imposed on a student found guilty of malpractice in order to:
    </Typography>
    <Box component="ul" sx={{ pl: 4 }}>
        <Typography component="li" variant="body1" paragraph>
            ensure that the candidate does not gain an unfair advantage;
        </Typography>
        <Typography component="li" variant="body1" paragraph>
maintain the integrity of the examination or testing session;
</Typography>
<Typography component="li" variant="body1" paragraph>
discourage other candidates from academic malpractice.
</Typography>
    </Box>




<Typography variant="body1" paragraph>
Students are required to read, understand and sign a comprehensive Academic Honesty Policy agreement which is given in the Learner Guardian Handbook.
</Typography>
<Typography variant="h6" gutterBottom fontWeight="bold">
4.1.1 Consequences of Academic Misconduct
</Typography>
<Typography variant="body1" paragraph>
Internally Administered Assessments
</Typography>
<Typography variant="body1" paragraph>
For any student who has been found to be academically dishonest in any of the above ways, there will be an escalating process of sanctions. The school recognizes that there are different levels of severity regarding academic honesty.
</Typography>
<Typography variant="body1" paragraph>
First offence: students will be asked to redo the work, but will receive no grade. Parents are to be informed. A student-parent-teacher conference may be held with them.
</Typography>
<Typography variant="body1" paragraph>
Second offence: students will have to redo the work but receive no grade and, where applicable, a non-submission will be indicated on the bi-monthly/interim report. A student-parent-teacher conference will be held, and a warning letter will be issued indicating that any further misdemeanor will result in a three-day academic suspension.
</Typography>
<Typography variant="body1" paragraph>
Third offence: students will not be able to redo the work, will receive no grade and where applicable, a non-submission will be indicated on the bi-monthly/interim term report. Students may have further sanctions ranging from suspension to being asked to withdraw from the school, depending on the severity.
</Typography>
<Typography variant="h6" gutterBottom fontWeight="bold">
Final Assessments Submitted to IBO:
</Typography>
<Typography variant="body1" paragraph>
If questions arise about the authenticity of a candidate's Personal Project/ ePortfolio/ Extended Essay/ Internal Assessments, before submission for assessment (or moderation), the situation will be resolved within the school.
</Typography>
<Typography variant="body1" paragraph>
First offence: If a teacher and/or Coordinator suspects that a student's work is plagiarized, they will be asked to resubmit it. Parents are to be informed. A student-parent-teacher conference will be held with them, and a warning letter will be issued regarding the consequences of a second violation.
</Typography>
<Typography variant="body1" paragraph>
Second offence: A second violation will result in the student being removed from that particular IB course. Hence they will not be able to participate in the MYP certificate or Diploma in that subject.
</Typography>
<Typography variant="body1" paragraph>
If academic misconduct (for example, plagiarism, collusion) is identified after a candidate's work has been submitted to the IB Organization for assessment (or moderation), the department Coordinator must inform the IB Organization as soon as possible. For the Personal Project / ePortfolio/ Extended Essay/ Internal Assessments, that are internally assessed, "submission" refers to the deadline by which teachers' grades must be submitted to the IB Organization.
</Typography>
<Typography variant="h6" gutterBottom fontWeight="bold">
Misconduct During Examinations
</Typography>
<Typography variant="body1" paragraph>
Taking unauthorized material into an examination, behaviour that disrupts the examination or distracts other candidates, communicating with another candidate, any other behaviour that gains an unfair advantage for a candidate or that affects the results of another candidate (for example, disclosure of information to and receipt of information from candidates about the content of an IB/on examination within 24 hours after the examination via any form of communication/media), is regarded as academic misconduct.
</Typography>
<Typography variant="h6" gutterBottom fontWeight="bold">
Misconduct During School Examinations
</Typography>
<Typography variant="body1" paragraph>
A confirmed incident of academic misconduct during any internal examination session will result in a cancellation of the said examination script.
</Typography>
<Typography variant="h6" gutterBottom fontWeight="bold">
Misconduct During IBO Examinations
</Typography>
<Typography variant="body1" paragraph>
Misconduct will be reported to the IBO and after investigation may result in no grade in that subject, hence compromising the award of the MYP Certificate or DP Diploma. Except in cases of serious or repeat misconduct, the candidate will be permitted to register for future examination sessions, which may include the session that follows six months later, if the relevant registration deadlines are met.
</Typography>
<Typography variant="body1" paragraph>
In the case of an MYP Certificate Candidate, if the session in which the academic misconduct has been established is the candidate's third examination session towards achieving the award of the MYP Certificate, no further IB examination sessions will be permitted.
</Typography>
<Typography variant="body1" paragraph>
In the Diploma Programme, if the candidate has already been found in breach of regulations in any previous session, this will normally lead to disqualification from participation in any future examination session.
</Typography>
<Typography variant="h6" gutterBottom fontWeight="bold">
Misconduct Pertaining to Community Service/CAS
</Typography>
<Typography variant="body1" paragraph>
Falsifying community service or CAS records, will result in a non-completion of community service or CAS requirements and no MYP Certificate/DP Diploma will be awarded to the candidate.
</Typography>
<Typography variant="h6" gutterBottom fontWeight="bold">
5. Cell Phones, Other Devices
</Typography>
<Typography variant="body1" paragraph>
The use of all cellphones is prohibited during school hours. Due to the distracting aspects of cell phones, their perceived influence on social status and their ability to transmit information electronically, any cell phone found in possession of a student will be confiscated.
</Typography>
<Typography variant="body1" paragraph>
First offence: the device will be returned to the student's parent whenever they are able to collect it from the school.
</Typography>
<Typography variant="body1" paragraph>
Second offence: the device will be confiscated for the entire term.
</Typography>
<Typography variant="body1" paragraph>
In the case of an emergency, students can use school phones to make calls with prior permission from the Coordinator.
</Typography>
<Typography variant="h6" gutterBottom fontWeight="bold">
Laptops, cameras, iPads, are allowed for project work, but remain the responsibility of the student.
</Typography>
<Typography variant="body1" paragraph>
If a student is caught using any such device during class without the prior permission of the teacher, it will be confiscated and returned to the student's parents whenever they are able to collect it from school. For second offence the device will be confiscated for the entire term.
</Typography>
<Typography variant="body1" paragraph>
The school is in no way responsible for loss or theft of the device. Laptops should not be used for any other purpose except work which is sanctioned by the teacher.
</Typography>
<Typography variant="body1" paragraph>
Explicit or offensive sites, if viewed within school premises, will result in a three days suspension.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
5.1. Storage of Devices in Lockers:
</Typography>
<Typography variant="body1" paragraph>
Students must store electronic devices, such as cell phones in their lockers under the following conditions:
</Typography>
<Box component="ul" sx={{ pl: 4 }}>
<Typography component="li" variant="body1" paragraph>
The International School is not responsible for any loss, theft or damage of these devices. The student stores such a device in their locker at their own risk.
</Typography>
<Typography component="li" variant="body1" paragraph>
No device must be powered off. A ringing cell phone in a locker will be subject to confiscation.
</Typography>
<Typography component="li" variant="body1" paragraph>
Use of cell phones is prohibited during school hours. Students caught with phones outside their lockers will be subject to disciplinary action and the device confiscated according to The International School's Code of Conduct.
</Typography>
</Box>
<Typography variant="body1" paragraph>
Students may pass their cell phones to the Coordinator's office in the morning till end of school day, if parents or students are comfortable with this option.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
6. Respect for School Property
</Typography>
<Typography variant="body1" paragraph>
The campus of the International School is our most immediate environment and must be respected.
</Typography>
<Typography variant="body1" paragraph>
Students are expected to place all rubbish in the bins and all recyclable bottles in their proper place. Any student caught purposefully littering will stay after school to help the domestic staff clean the yard. Any disrespect to the property or structure of The International School in the form of vandalism will result in immediate disciplinary action. Complete restoration of said property will be the minimum punishment issued, and the financial responsibility will be borne by the student.
</Typography>
<Typography variant="body1" paragraph>
Electrical appliances such as blow-dryers, projectors, air conditioners, etc. must not be handled without the consent of the teacher.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
7. Respect for the School Name
</Typography>
<Typography variant="body1" paragraph>
Students are considered ambassadors for our school and should set a good example at all times.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
7.1. Social Networks
</Typography>
<Typography variant="body1" paragraph>
If at any time, any student is found to have posted negative comments on any social networking site related to the school or teachers of the TIS, strict action will be taken by the Disciplinary Committee. Suspension or expulsion will be given with immediate effect, depending on the severity of the post.
</Typography>
<Typography variant="body1" paragraph>
The use of Facebook or any other social network is strictly prohibited in the school premises.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
7.2. Extra-Curricular Activities
</Typography>
<Typography variant="body1" paragraph>
Any misconduct during extra-curricular activities will result in disciplinary action to be taken, on the next school day, as per the school's Code of Conduct.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
7.3. Behavior Outside the School Premises
</Typography>
<Typography variant="body1" paragraph>
TIS students are expected to behave respectfully and responsibly at all times inside and outside the school premises, especially while wearing the school uniform. This includes driving without a valid licence. Such offences are subject to disciplinary action and parents will be notified.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
7.4. Field Trips or CAS activities
</Typography>
<Typography variant="body1" paragraph>
All field trips are carefully planned by teachers with the express intention of complementing classroom learning. These trips are seen as an important part of your child's education and students are therefore expected to participate whenever possible.
</Typography>
<Typography variant="body1" paragraph>
Each trip will have a designated supervisor (e.g. a teacher or an administrator) who has the authority for all students and activities on the trip. The supervisor has the authority to mete out disciplinary measures or escort a student back to TIS at his/her discretion. The supervisor may have other school personnel on the trip in order to maintain a 10:1 ratio of students to teachers. This is needed to ensure appropriate supervision of all students on the trip.
</Typography>

<Typography variant="body1" paragraph>
7.4.1. Specific rules for TIS sponsored field trips include the following:
</Typography>
<Box component="ul" sx={{ pl: 4 }}>
<Typography component="li" variant="body1" paragraph>
In order to participate in any field trip or out-of-school excursion, children must return a signed field trip permission form at least 24 hours prior to the trip. A child who is not permitted to attend a trip will be supervised in school if possible. If this is not possible, parents will be notified to make alternate arrangements.
</Typography>
<Typography component="li" variant="body1" paragraph>
Parents must alert the supervisor, in writing, of any temporary, chronic or acute medical conditions before allowing a student to go on a field trip. If a student attempts to go on a field trip while ill, TIS has the right to deny the student to participate.
</Typography>
<Typography component="li" variant="body1" paragraph>
Field trips are designed to be complement run by TIS faculty and staff. Parents cannot visit students while on a field trip, nor can parents volunteer to chaperone field trips without permission from the Principal.
</Typography>
<Typography component="li" variant="body1" paragraph>
The Principal or Coordinator has the right to bar any student from going on a field trip. Reasons for this may include being on academic probation, prior violations of the Code of Conduct, and excessive absences from school or otherwise.
</Typography>
<Typography component="li" variant="body1" paragraph>
Unless otherwise specified by the supervisor, all students must dress in the correct and neat school uniform while on field trips.
</Typography>
</Box>

<Typography variant="h6" gutterBottom fontWeight="bold">
8. Prohibited Items
</Typography>
<Typography variant="body1" paragraph>
Under no circumstances are students permitted to bring fire crackers, acid, weapons, drugs, cigarettes, alcohol, pornographic material, or any other article deemed indecent, harmful or prohibited by law, onto the school premises. Such cases will be subject to severe disciplinary action and/or expulsion.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
9. Food and Beverages
</Typography>
<Typography variant="body1" paragraph>
In order to maintain cleanliness within the classrooms, food and beverages are not allowed to be consumed inside the school building, unless permission is given by the concerned teacher. In addition, students are only allowed to make purchases from the canteen during break time or free periods. Snacks from home are also encouraged. No student is allowed to order food from outside school.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
10. Break Times and Free Periods
</Typography>
<Typography variant="body1" paragraph>
Students are required to be building during break unless they are completing extra work assigned by the teachers. In such cases, the students must be supervised by the concerned teacher. Students may enter the building to use the bathroom. The same rules apply to students who have a free period. All classrooms will be locked during both breaks.
</Typography>
<Typography variant="body1" paragraph>
Students are not permitted to leave the classroom within the first 15 minutes between classes unless they are in transit to another class. If a student needs to use the bathroom outside of break time, they must wait to ask the teacher's permission. Students who leave the classroom between classes will be considered late for the next class and subject to disciplinary action as mentioned above.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
11. Dress Code
</Typography>
<Typography variant="body1" paragraph>
The International School considers it important that students appear neat, clean and well groomed at all times. It is the responsibility of the student to dress in an appropriate manner. It is recommended that the uniform be purchased from school specified vendors only.
</Typography>

<Typography variant="body1" paragraph>
BOYS:
</Typography>
<Box component="ul" sx={{ pl: 4 }}>
<Typography component="li" variant="body1" paragraph>
Short/Long white sleeve shirts with new school monogram.
</Typography>
<Typography component="li" variant="body1" paragraph>
ONLY white under shirt or vest.
</Typography>
<Typography component="li" variant="body1" paragraph>
Dark brown trousers.
</Typography>
<Typography component="li" variant="body1" paragraph>
Dark brown belt.
</Typography>
<Typography component="li" variant="body1" paragraph>
Plain black or white socks.
</Typography>

<Typography component="li" variant="body1" paragraph>
Plain black laced shoes or moccasins with NO buckles (NEITHER sandals NOR platform shoes).
</Typography>
<Typography component="li" variant="body1" paragraph>
In winter, the students may wear plain black cardigans or sweaters.
</Typography>
<Typography component="li" variant="body1" paragraph>
Hair should be neatly combed or tied. 
</Typography>
<Typography component="li" variant="body1" paragraph>
Facial hair must be neatly trimmed and managed.
</Typography>
<Typography component="li" variant="body1" paragraph>
Students are NOT permitted to wear jewellery, except for plain watches with no form of other gadgetry allowed. No piercings (e.g. facial) are permitted.
</Typography>
<Typography component="li" variant="body1" paragraph>
No facial or head tattoos allowed.
</Typography>
<Typography component="li" variant="body1" paragraph>
Green and black striped school tie - tied correctly with the top shirt button done up.
</Typography>
<Typography component="li" variant="body1" paragraph>
Green or black belt.
</Typography>
<Typography component="li" variant="body1" paragraph>
Black OR white tracks
</Typography>
<Typography component="li" variant="body1" paragraph>
Continent T-shirts
</Typography>
<Typography component="li" variant="body1" paragraph>
Joggers of any colour
</Typography>
</Box>
<Typography variant="body1" paragraph>
GIRLS:
</Typography>
<Box component="ul" sx={{ pl: 4 }}>
<Typography component="li" variant="body1" paragraph>
Short/Long sleeve white shirts with new school monogram, dark green trousers OR dark green skirt with black belt OR
</Typography>
<Typography component="li" variant="body1" paragraph>
White shalwar kameez (with green collar and cuff) with the new school monogram and green sash.
</Typography>
<Typography component="li" variant="body1" paragraph>
Plain white socks.
</Typography>
<Typography component="li" variant="body1" paragraph>
Plain black laced shoes or moccasins with NO buckles (NEITHER sandals NOR platform shoes).
</Typography>
<Typography component="li" variant="body1" paragraph>
Black OR white headscarves (optional)
</Typography>
<Typography component="li" variant="body1" paragraph>
In winter, the students may wear plain black cardigans or sweaters.
</Typography>
<Typography component="li" variant="body1" paragraph>
Hair of shoulder-length hair or longer will be varied or tied back neatly away from the face. Only black or brown coloured clips/ties are allowed for hair. Hair bands of the same colour are also allowed.
</Typography>
<Typography component="li" variant="body1" paragraph>
Students are NOT permitted to wear jewellery, except for plain watches with no form of other gadgetry allowed.
</Typography>
<Typography component="li" variant="body1" paragraph>
One pair of simple earrings (studs or small rings). Other piercings (e.g. facial) are not allowed.
</Typography>
<Typography component="li" variant="body1" paragraph>
Students are NOT permitted to wear make-up, nail polish, hair extensions etc., NOR wear nose/eyebrow/toe rings NOR CAPS. Such items will be confiscated for the remainder of the school term.
</Typography>
</Box>

<Typography variant="body1" paragraph>
NB: It is mandatory for all students to wear the TIS student ID card as part of their uniform at all times.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
11.1 Dress Code for extended PHE classes:
</Typography>
<Typography variant="body1" paragraph>
The uniform for extended PHE classes is as follows
</Typography>
<Typography variant="body1" paragraph>
Black OR white tracks
</Typography>
<Typography variant="body1" paragraph>
Continent T-shirts
</Typography>
<Typography variant="body1" paragraph>
Joggers of any colour
</Typography>

<Typography variant="body1" paragraph>
On days when extended PHE classes are scheduled, students must wear the sports uniform all day. In the event that the student is unwell, he/she will be able to continue with a written assignment in lieu of physical exercise, on submission of a medical certificate. Illness/injury does not exempt the student from attending the class or wearing the required sports uniform.
</Typography>

<Typography variant="body1" paragraph>
Penalties for violation of the dress code are as follows:
</Typography>
<Typography variant="body1" paragraph>
First offence: a verbal warning will be issued to the student
</Typography>
<Typography variant="body1" paragraph>
Second offence: an email will be sent to parents
</Typography>
<Typography variant="body1" paragraph>
Third offence: the students will be sent home
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
11.2 Mufti Days (Non-Uniform Days)
</Typography>
<Typography variant="body1" paragraph>
On occasions, school may allow students to wear home clothes. On these days students are required to dress modestly and appropriately; (no shorts, no sleeveless, no miniskirts, no flip flops). Local cultural sensitivities must be respected.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
12. Bullying
</Typography>
<Typography variant="body1" paragraph>
Students must, at all times, be respectful of their fellow schoolmates. It is not acceptable in any way for students to unfairly influence or bully other students.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
12.1 Bullying And Cyber bullying
</Typography>
<Typography variant="body1" paragraph>
Bullying is when someone hurts or scares another person on purpose and the person being bullied has a hard time defending himself or herself.
</Typography>
<Typography variant="body1" paragraph>
Usually, bullying happens repeatedly. This can include:
</Typography>
<Box component="ul" sx={{ pl: 4 }}>
<Typography component="li" variant="body1" paragraph>
Punching, shoving, and other acts that hurt people physically
</Typography>
<Typography component="li" variant="body1" paragraph>
Spreading rumours about people
</Typography>
<Typography component="li" variant="body1" paragraph>
Keeping certain people out of a "group"
</Typography>
<Typography component="li" variant="body1" paragraph>
Teasing people in a mean way
</Typography>
<Typography component="li" variant="body1" paragraph>
Getting certain people to "gang up" on others
</Typography>
</Box>

<Typography variant="body1" paragraph>
Cyber bullying is when children or teens bully each other using the Internet, mobile phones or other cyber technology. This can include:
</Typography>
<Box component="ul" sx={{ pl: 4 }}>
<Typography component="li" variant="body1" paragraph>
Sending mean texts, emails, or instant messages
</Typography>
<Typography component="li" variant="body1" paragraph>
Posting nasty pictures or messages about others in blogs or on websites
</Typography>
<Typography component="li" variant="body1" paragraph>
Using someone else's user name
</Typography>
</Box>

<Typography variant="body1" paragraph>
Bullying or cyber bullying at TIS is not tolerated. All TIS students are expected to help prevent bullying by supporting one another and reporting any and all instances of bullying or cyber bullying to a teacher or the Disciplinary Committee.
</Typography>
<Typography variant="body1" paragraph>
Reporting can be done in person or by sending an email. Students found bullying others can be suspended and/or expelled from school.
</Typography>
<Typography variant="body1" paragraph>
Being a witness to bullying or cyber bullying and not reporting it to an adult is as damaging as being the bully yourself. Everyone has a responsibility to help prevent bullying or cyber bullying from occurring and to help those being bullied.
</Typography>
<Typography variant="body1" paragraph>
If a student is caught exhibiting such behavior, they will be dealt with in a severe manner. If parents feel that their child is being unfairly influenced at school, they are urged to contact the school to discuss the issue. Students, who are either the victim or the bully, can be asked to go for counseling.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
12.2 Fighting
</Typography>
<Typography variant="body1" paragraph>
Physical violence is a very serious issue. Students are caught fighting, they will face the possibility of a suspension, ranging from 1 to 5 days, the length of which will depend on the severity of the case.
</Typography>
<Typography variant="body1" paragraph>
When a fight occurs, it will be investigated by the Disciplinary Committee to attempt to determine the cause and provocation of the skirmish. In all cases, the student who strikes first will be more severely punished, as violence is never the correct solution, even when provoked. The other student may or may not be disciplined, depending on the situation.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
13. Science Laboratory Safety Rules
</Typography>
<Typography variant="body1" paragraph>
Students should conduct themselves in a responsible manner at all times in the science laboratory. Special attention must be given to the following:
</Typography>
<Box component="ul" sx={{ pl: 4 }}>
<Typography component="li" variant="body1" paragraph>
Students must not enter the lab without permission from the respective teacher.
</Typography>
<Typography component="li" variant="body1" paragraph>
Students must enter the laboratory wearing a lab coat.
</Typography>
<Typography component="li" variant="body1" paragraph>
Students must perform only those laboratory activities which are permitted by the teacher.
</Typography>
<Typography component="li" variant="body1" paragraph>
Students must follow all written and verbal instructions given by the teacher, precisely.
</Typography>
<Typography component="li" variant="body1" paragraph>
Students should work responsibly and quietly in the laboratory to avoid any accidents.
</Typography>
<Typography component="li" variant="body1" paragraph>
All accidents, breakage/leakage of apparatus should be reported to the teacher immediately, no matter how minor.
</Typography>
<Typography component="li" variant="body1" paragraph>
Safety goggles must be worn when working with chemicals.
</Typography>
<Typography component="li" variant="body1" paragraph>
Great care must be taken in noting odours or fumes. These should be noted using waft motion of the hand. Never put a bottle to your nose and breathe deeply.
</Typography>
<Typography component="li" variant="body1" paragraph>
Students must use a cloth/holder when handling heated apparatus.
</Typography>
<Typography component="li" variant="body1" paragraph>
Students must not taste any chemicals, nor pour any into other chemicals unless instructed otherwise.
</Typography>
<Typography component="li" variant="body1" paragraph>
Students should not bring any substance into contact with a flame unless specifically instructed to do so by the teacher.
</Typography>
<Typography component="li" variant="body1" paragraph>
Prolonged use of the sun, infrared, ultraviolet light or laser sources should be avoided at all times.
</Typography>
<Typography component="li" variant="body1" paragraph>
Horseplay, running, pushing, shoving and practical jokes will not be tolerated.
</Typography>
<Typography component="li" variant="body1" paragraph>
Every injured person, and every spilled chemical, must be reported to the teacher immediately, no matter how minor.
</Typography>
<Typography component="li" variant="body1" paragraph>
Laboratory glassware should be thoroughly (15) times) with soap at the conclusion of each experiment or laboratory class.
</Typography>
<Typography component="li" variant="body1" paragraph>
Students should always clean and wipe dry all desks, tables or laboratory work areas, at the end of each experiment or laboratory period.
</Typography>
<Typography component="li" variant="body1" paragraph>
Students should know the location of the first aid kit and fire fighting-equipment and emergency exit.
</Typography>
<Typography component="li" variant="body1" paragraph>
No food, drinks or cameras are allowed in the laboratory without prior permission from the teacher, for recording purpose only.
</Typography>
<Typography component="li" variant="body1" paragraph>
No food or beverages are permitted in the science laboratory.
</Typography>
<Typography component="li" variant="body1" paragraph>
In case of any accidents, all students must be aware of the shower area and eye-wash station.
</Typography>
</Box>

<Typography variant="h6" gutterBottom fontWeight="bold">
14. Art Room Regulations
</Typography>
<Typography variant="body1" paragraph>
Students should conduct themselves in a responsible manner at all times in the art class. Special attention should be given to the following:
</Typography>
<Box component="ul" sx={{ pl: 4 }}>
<Typography component="li" variant="body1" paragraph>
It is the student's responsibility to bring an apron to protect their uniform.
</Typography>
<Typography component="li" variant="body1" paragraph>
Students will not be allowed to do any painting work without wearing aprons.
</Typography>
<Typography component="li" variant="body1" paragraph>
All loose sheets must be organized in the students own art file.
</Typography>
<Typography component="li" variant="body1" paragraph>
All accidents must be reported to the teacher immediately, no matter how minor.
</Typography>
<Typography component="li" variant="body1" paragraph>
No other activities should be performed, where instructions and permission have been given by the teacher.
</Typography>
<Typography component="li" variant="body1" paragraph>
Any materials and equipment authorized by the teacher should be used.
</Typography>
<Typography component="li" variant="body1" paragraph>
Work areas should be kept clean and tidy at the end of all activities.
</Typography>
<Typography component="li" variant="body1" paragraph>
In winter, jackets and sweaters should be removed. Long hair should be tied back during all activities.
</Typography>
<Typography component="li" variant="body1" paragraph>
All work areas should be kept clean and all broken glass should be removed. Long hair should be tied back during laboratory activities.
</Typography>
<Typography component="li" variant="body1" paragraph>
Laboratory glass should be removed from work areas and the floor as soon as possible. Never handle broken glass with your bare hand; domestic staff must be called to clean up.
</Typography>
<Typography component="li" variant="body1" paragraph>
Horseplay, running, pushing, shoving and practical jokes will not be tolerated.
</Typography>
<Typography component="li" variant="body1" paragraph>
No student is allowed to use the art room as a common room or visit art students during the class.
</Typography>
<Typography component="li" variant="body1" paragraph>
Mobile phones, cameras are allowed in the Art Room (unless prior permission has been issued by the teacher).
</Typography>
<Typography component="li" variant="body1" paragraph>
Misuse of video cameras, multimedia, computers, digital cameras or any part of equipment will result in student losing privileges to work, or removal from class.
</Typography>
<Typography component="li" variant="body1" paragraph>
In the case of students who carry IT items immediately lose all computer privileges.
</Typography>
<Typography component="li" variant="body1" paragraph>
All IT material or projects should be saved on the Art Room computers or stored in designated storage areas.
</Typography>
<Typography component="li" variant="body1" paragraph>
The school is not responsible for the loss of any Art material or projects.
</Typography>
<Typography component="li" variant="body1" paragraph>
Strictly prohibited are unapproved displays. Suspensions will be issued in such cases.
</Typography>
<Typography component="li" variant="body1" paragraph>
Students should know the location of the first aid kit and fire fighting-equipment

and emergency exit.
</Typography>
</Box>

<Typography variant="h6" gutterBottom fontWeight="bold">
15. Library Rules and Regulations
</Typography>
<Typography variant="body1" paragraph>
Students must follow the following rules while using the Library:
</Typography>
<Box component="ul" sx={{ pl: 4 }}>
<Typography component="li" variant="body1" paragraph>
students are allowed to use the library for research and reading purposes only.
</Typography>
<Typography component="li" variant="body1" paragraph>
Silence and discipline must be observed at all times.
</Typography>
<Typography component="li" variant="body1" paragraph>
Group discussions are only permitted with the instruction and supervision of a teacher.
</Typography>
<Typography component="li" variant="body1" paragraph>
Students must observe proper decorum
</Typography>
<Typography component="li" variant="body1" paragraph>
Seats must be returned to their proper places after use.
</Typography>
<Typography component="li" variant="body1" paragraph>
students must not write on or mark any material; fines will be charged for damages incurred.
</Typography>
<Typography component="li" variant="body1" paragraph>
students are required to leave books on the table after use; do not shelve them.
</Typography>
<Typography component="li" variant="body1" paragraph>
students can borrow two books at one time, for a period of two weeks. Additional books be borrowed after written consent to the Librarian from the subject teacher/supervisor.
</Typography>
<Typography component="li" variant="body1" paragraph>
after the due date, a fine will be chargeable at the rate of Rs. 15 per day per book.
</Typography>
<Typography component="li" variant="body1" paragraph>
in case of loss of books or other library material the current market price plus a fine for the whole period (after due date) will be charged.
</Typography>
<Typography component="li" variant="body1" paragraph>
current newspapers, magazines, journals and reference books may not be borrowed or removed from the library.
</Typography>
<Typography component="li" variant="body1" paragraph>
bags are not allowed in the library.
</Typography>
<Typography component="li" variant="body1" paragraph>
all personal books/materials must be declared to the Librarian on entering.
</Typography>
<Typography component="li" variant="body1" paragraph>
eating or drinking is prohibited in the library.
</Typography>
<Typography component="li" variant="body1" paragraph>
in the event of misbehaviour, the Librarian has the discretion to ask the student or a whole group of students to leave.
</Typography>
<Typography component="li" variant="body1" paragraph>
a library clearance certificate must be obtained by all students who are leaving The International School.
</Typography>
</Box>


<Typography variant="h6" gutterBottom fontWeight="bold">
16. IT Laboratory Rules
</Typography>
<Typography variant="body1" paragraph>
Students must follow the following rules while using the IT laboratory:
</Typography>
<Box component="ul" sx={{ pl: 4 }}>
<Typography component="li" variant="body1" paragraph>
students must follow the instructions given by the lab technicians and assistants.
</Typography>
<Typography component="li" variant="body1" paragraph>
students must responsibly operate all equipment properly and report any problems immediately.
</Typography>
<Typography component="li" variant="body1" paragraph>
the IT lab is intended to be used for educational purposes only.
</Typography>
<Typography component="li" variant="body1" paragraph>
students must shut down the computer when they are finished using it and push in the chair before leaving.
</Typography>
<Typography component="li" variant="body1" paragraph>
students may work in groups, quietly.
</Typography>
<Typography component="li" variant="body1" paragraph>
disruptive behavior will not be tolerated at all.
</Typography>
<Typography component="li" variant="body1" paragraph>
pornography is prohibited on the campus.
</Typography>
<Typography component="li" variant="body1" paragraph>
if your instructor has asked you to view a site that might be questionable, please inform the lab assistant or technician in advance.
</Typography>
<Typography component="li" variant="body1" paragraph>
printing is only permitted with prior permission.
</Typography>
<Typography component="li" variant="body1" paragraph>
students are not permitted to install software on units in the lab. This includes the downloading of shareware, freeware, and evaluation copies of software from the internet.
</Typography>
<Typography component="li" variant="body1" paragraph>
copying any copyrighted material, such as music, is prohibited.
</Typography>
<Typography component="li" variant="body1" paragraph>
no food and/or drinks are allowed in the IT lab.
</Typography>
<Typography component="li" variant="body1" paragraph>
during break times, the students are not allowed to sit in the IT lab unless supervised.
</Typography>
<Typography component="li" variant="body1" paragraph>
the privacy of all users must be respected; all students must focus on their own screen.
</Typography>
</Box>

<Typography variant="h6" gutterBottom fontWeight="bold">
17. The Locker Policy
</Typography>
<Typography variant="body1" paragraph>
All lockers assigned to students are the property of The International School. At no time does the school relinquish its exclusive control of its lockers. Students are permitted to store personal items and electronic devices such as cell phones in their lockers according to the following guidelines:
</Typography>
<Box component="ul" sx={{ pl: 4 }}>
<Typography component="li" variant="body1" paragraph>
students and their parents will be informed of the rules and conditions of locker use and locker searches after admission
</Typography>
<Typography component="li" variant="body1" paragraph>
a locker will not be assigned until both student and parent have signed the Locker Policy. Signing the policy indicates that it has been read and understood and the student agrees to abide by the conditions therein.
</Typography>
<Typography component="li" variant="body1" paragraph>
the International School reserves the right to change the locker policy. Any changes to the Locker Policy will be posted within the school and a notice sent home to parents.
</Typography>
</Box>

<Typography variant="h6" gutterBottom fontWeight="bold">
17.1 Locker assignment
</Typography>
<Box component="ul" sx={{ pl: 4 }}>
<Typography component="li" variant="body1" paragraph>
Lockers will be labelled in the following alpha-numeric series, starting TIS-001 onwards.
</Typography>
<Typography component="li" variant="body1" paragraph>
A locker will be assigned to a student for use during the school year based on the following rules and conditions of use:
</Typography>
<Box component="ul" sx={{ pl: 4 }}>
<Typography component="li" variant="body1" paragraph>
    students are responsible for their assigned lockers. The locker is not to be used by any unauthorized person. Students may not switch lockers without the express written permission of the Coordinator or Principal.
</Typography>
<Typography component="li" variant="body1" paragraph>
    students are to provide their own locks as long as it does not impede the opening of an adjacent locker.
</Typography>
<Typography component="li" variant="body1" paragraph>
    combination locks are recommended.
</Typography>
<Typography component="li" variant="body1" paragraph>
    the International School is not responsible for loss, theft or damage of material stored in student lockers.
</Typography>
<Typography component="li" variant="body1" paragraph>
    students may decorate the interior of their lockers, but any permanent changes will be considered vandalism of school property and are strictly prohibited. Decorations must be decent and appropriate.
</Typography>
<Typography component="li" variant="body1" paragraph>
    no illegal substances, weapons or other prohibited or offensive materials are to be placed in school lockers.
</Typography>
<Typography component="li" variant="body1" paragraph>
    permission to use the locker may be terminated where a student does not comply with the conditions of use or school policies or rules.
</Typography>
</Box>
</Box>

<Typography variant="h6" gutterBottom fontWeight="bold">
17.2 Locker Searches
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
17.2.1 Named searches
</Typography>
<Typography variant="body1" paragraph>
a. School officials may search a student's locker in those instances where there exists reasonable grounds to do so, and without prior notice, in order to ensure compliance with the conditions of use and other school policies and rules. Every effort will be made to ensure that the student and a member of the Disciplinary Committee will be present when a locker is searched, except in an emergency situation.
</Typography>
<Typography variant="body1" paragraph>
b. The following criteria must be considered by a school administrator in the determination that reasonable grounds exist to conduct a search:
</Typography>
<Box component="ul" sx={{ pl: 4 }}>
<Typography component="li" variant="body1" paragraph>
i. credible information received from one or more student(s);
</Typography>
<Typography component="li" variant="body1" paragraph>
ii. the Principal's or Coordinator's own observation;
</Typography>
<Typography component="li" variant="body1" paragraph>
iii. a Teacher or Admin Staff's own observation;
</Typography>
<Typography component="li" variant="body1" paragraph>
iv. any combination of the above.
</Typography>
</Box>
<Typography variant="body1" paragraph>
c. If any student refuses to allow a locker to be searched, The International School reserves the right to cut the lock in order to conduct a search.
</Typography>
<Typography variant="body1" paragraph>
d. If a student has reason to believe that any locker contains material that may threaten the safety of other persons, that student is expected to immediately report the information to a teacher or the school administration. The name of the student making the report will be kept confidential.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
17.2.2 Random Locker Searches
</Typography>
<Typography variant="body1" paragraph>
a. From time to time, The International School reserves the right to randomly search whole banks of class lockers to ensure adherence to the Locker Policy and The International School Code of Conduct.
</Typography>
<Typography variant="body1" paragraph>
b. On random locker searches, the following procedures will be followed:
</Typography>
<Box component="ul" sx={{ pl: 4 }}>
<Typography component="li" variant="body1" paragraph>
i. prior to the search, students will be informed that their lockers have been secured.
</Typography>
<Typography component="li" variant="body1" paragraph>
ii. students will then be asked to remove their personal lock in the presence of one or more members of the Disciplinary Committee.
</Typography>
<Typography component="li" variant="body1" paragraph>
iii. if any student refuses to allow a locker to be searched, The International School reserves the right to cut the lock in order to conduct a search.
</Typography>
<Typography component="li" variant="body1" paragraph>
iv. any contraband, prohibited, or stolen materials found in locker searches will be confiscated and dealt with in accordance with The International School's Code of Conduct.
</Typography>
<Typography component="li" variant="body1" paragraph>
v. any vandalism discovered during searches will result in the students in question losing their locker privileges. In addition, any costs associated with returning the locker to its original state, will be borne by the student.
</Typography>
</Box>
<Typography variant="body1" paragraph>
Confiscations may result from any of these searches.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
17.2.3 Accessing Lockers
</Typography>
<Typography variant="body1" paragraph>
a. Students may access their lockers during the following times:
</Typography>
<Box component="ul" sx={{ pl: 4 }}>
<Typography component="li" variant="body1" paragraph>
i. before school
</Typography>
<Typography component="li" variant="body1" paragraph>
ii. during breaks
</Typography>
<Typography component="li" variant="body1" paragraph>
iii. during free periods
</Typography>
<Typography component="li" variant="body1" paragraph>
iv. after home time (until 5:00 pm)
</Typography>
</Box>
<Typography variant="body1" paragraph>
b. Students are not permitted to access their lockers during class time without the express consent of the subject teacher.
</Typography>
<Typography variant="body1" paragraph>
c. Given the close proximity of the lockers, students are expected to access their lockers in a responsible and safe manner. Any reckless actions or misconduct while accessing lockers will be subject to disciplinary action.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
17.3 Loss of Key or Combination of the Lock
</Typography>
<Typography variant="body1" paragraph>
a. Students are encouraged to store an extra key, or a copy of their combination, with the department Coordinator.
</Typography>
<Typography variant="body1" paragraph>
b. If a student is unable to open their lock due to loss of keys or combination, they are responsible for bearing any costs of opening the lock.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
17.4 Personal Search and Confiscation
</Typography>
<Typography variant="body1" paragraph>
Any member of the Disciplinary Committee may conduct a search of a student if there is reasonable belief that a student has in his/her possession an item or evidence of an activity which is contrary to the school rules, in breach of law, or the student's contract with the school. The search of a person shall be conducted by a member of staff of the same gender as the person being searched and in the presence of one additional person entitled to make the search.
</Typography>
<Typography variant="body1" paragraph>
Any member of the Disciplinary Committee may also conduct a search of electronic devices and systems, and any part of the school premises, including lockers, book bags, desks, laptops and cupboards.
</Typography>
<Typography variant="body1" paragraph>
Confiscations may result from any of these searches.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
18. Glossary of Repercussions
</Typography>
<Typography variant="body1" paragraph>
Violations of the Code of Conduct may result in any of the following:
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
18.1 After school detentions
</Typography>
<Typography variant="body1" paragraph>
Students may be required to complete written work or to sit quietly where assigned. Parents will be notified in advance, informing them of the date and time so that alternate arrangements for transportation can be made. Disruptive behaviour during detention will result in an additional after-school detention.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
18.2 Suspension
</Typography>
<Typography variant="body1" paragraph>
As attendance at school is of the utmost importance, suspensions are reserved for more serious infractions and/or continual misbehaviour. A suspension can be issued by the Disciplinary Committee, Coordinator or Principal, who will also determine the duration of the suspension. The parents will be contacted by telephone at the time the suspension is issued, and a letter will be sent home indicating that a suspension will be reflected in the student's permanent record, which must be acknowledged, signed and sent back to the school. After the suspension has been served, a meeting will be scheduled for the parents and student to discuss the situation with the Coordinator and/or Principal, and any teachers or staff directly involved.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
18.3 Expulsion
</Typography>
<Typography variant="body1" paragraph>
In extreme cases, or prolonged misbehaviour and disobedience, a student may be permanently expelled from school. Due to the serious nature of an expulsion, it can only be issued by the consensus of a committee composed of the Principal, Coordinators, Disciplinary Committee. The student and his or her parents will be a part of this process and have the opportunity to make an appeal for the student.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
19. Lost And Found
</Typography>
<Typography variant="body1" paragraph>
It is the responsibility of all students to hand in any item found on the school property to the purchasing department next to the canteen.
</Typography>

<Typography variant="h6" gutterBottom fontWeight="bold">
20. Parent Concerns
</Typography>
<Typography variant="body1" paragraph>
Parents who have concerns about any classroom issues should privately discuss the matter with the concerned teacher by arranging an appointment, in the presence of the Coordinator. If the matter is not resolved to the parents' satisfaction, a parent's next course of action is to refer the issue to the Head of School.
</Typography>
<Typography variant="h6" gutterBottom fontWeight="bold">
21. Other Offences
</Typography>
<Typography variant="body1" paragraph>
The above list is to be considered a guideline; it is by no means exhaustive. Any misbehaviour, other than those listed above, will be subject to disciplinary action at the discretion of the Principal or Coordinator and the teachers involved.
</Typography>
<Typography variant="body1" paragraph>
If changes are made to the Code of Conduct during the academic year, parents will be duly informed.
</Typography>

</Box>);
};
